import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initAnalytics, trackPageView } from "@/lib/analytics";

// Fires a single, deduped GA4 page_view for every genuine route load.
// Analytics is gated to production hostnames only via initAnalytics().
export default function Analytics() {
  const { pathname, search } = useLocation();
  useEffect(() => { initAnalytics(); }, []);
  useEffect(() => {
    const page_path = `${pathname}${search}`;
    if (!page_path) return;
    trackPageView({
      path: page_path,
      location: typeof window !== "undefined" ? window.location.href : "",
      title: typeof document !== "undefined" ? document.title : "",
    });
  }, [pathname, search]);
  return null;
}
